export default [
    {
        path: "online-transaction-report",
        name: "onlinetransactionreport",
        component: () =>
            import(
                /* webpackChunkName: "OnlineTransactionReport" */ "../pages/onlineTransactionReport/OnlineTransactionReport.vue"
            ),
        meta: {
            title: `Transaction Report`,
        },
    }
];
